import { useDispatch, useSelector } from 'react-redux';

import { Select, MenuItem } from '@mui/material';
import { useTranslation } from 'next-i18next';

import Style from './style';

import courseActions from 'src/redux/course/actions';
import { RootState } from 'src/redux/reducer';
import { useEffect, useState } from 'react';

const { set_course_api_sort_order } = courseActions;

type CourseSortOrderItemProps = {
  name: string;
  value: string;
  isSelected?: boolean;
};

const initSortOrderItems: CourseSortOrderItemProps[] = [
  {
    name: 'all_course.sort_order.publish_desc',
    value: 'publish_desc',
  },
  {
    name: 'all_course.sort_order.publish_asc',
    value: 'publish_asc',
  },
  {
    name: 'all_course.sort_order.price_asc',
    value: 'price_asc',
  },
  {
    name: 'all_course.sort_order.price_desc',
    value: 'price_desc',
  },
];

const initDefaultSelected = 'publish_desc';

const SortOrderFormControl = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation('common');
  const { query } = useSelector((state: RootState) => ({
    query: state.Course.get('courseApiQueries'),
  }));
  const [sortOrderItems, setSortOrderItems] = useState<CourseSortOrderItemProps[]>(initSortOrderItems);

  const [defaultSelected, setDefaultSelected] = useState<string>(initDefaultSelected);

  const handleChange = (event: any) => {
    const [valueOfSortBy, valueOfoOderBy] = event.target.value.split('_');
    if (valueOfSortBy && valueOfoOderBy) {
      dispatch(set_course_api_sort_order({ ...query, sortBy: [valueOfSortBy], orderBy: [valueOfoOderBy] }));
    } else {
      const { sortBy, orderBy, ...exceptSort } = query;
      dispatch(set_course_api_sort_order({ ...exceptSort }));
    }
  };

  useEffect(() => {
    if (!query.q) {
      setSortOrderItems(initSortOrderItems);
      setDefaultSelected(initDefaultSelected);
      return;
    }

    const defaultSortOrderItemIndex = sortOrderItems.findIndex((item) => item.value === 'default');
    if (defaultSortOrderItemIndex !== -1) return;

    setSortOrderItems((value) =>
      [
        {
          name: 'all_course.sort_order.most_similar',
          value: 'default',
        },
      ].concat(value),
    );

    setDefaultSelected('default');
  }, [query]);
  return (
    <Style size="small" sx={{ m: 0, minWidth: 150 }}>
      <Select
        labelId="sort-order-select-label"
        id="sort-order-select"
        value={query.sortBy && query.orderBy ? `${query.sortBy}_${query.orderBy}` : defaultSelected}
        onChange={handleChange}
        displayEmpty
      >
        {sortOrderItems.map((sortOrderItem) => (
          <MenuItem
            key={`selection-${sortOrderItem.value}`}
            value={sortOrderItem.value}
            sx={{
              fontFamily: 'Lanna',
              fontSize: '18px',
            }}
          >
            {t(sortOrderItem.name)}
          </MenuItem>
        ))}
      </Select>
    </Style>
  );
};

export default SortOrderFormControl;
